import { render, staticRenderFns } from "./OverflowContainer.vue?vue&type=template&id=65b779fd&scoped=true&"
var script = {}
import style0 from "./OverflowContainer.vue?vue&type=style&index=0&id=65b779fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b779fd",
  null
  
)

export default component.exports